import type { RuntimeConfig } from "nuxt/schema";

export const useGetBaseUrl = (router: URL, runtimeConfig: RuntimeConfig) => {
  const appName = ["fuat", "int02", "test"].includes(
    runtimeConfig.public.envName
  )
    ? `${runtimeConfig.public.appName}.`
    : "www.";

  return `${router.protocol}//${appName}${runtimeConfig.public.domain}`;
};
